<template>
    <div class="field" :class="{'is-error': isInvalid}">
        <label v-if="label" class="field-label">{{label}}</label>
        <div class="field-group">
            <div class="field-control has-image-right">
                <input class="field-input" v-model="formattedCardNumber" @input="input" v-fs-block/>
                <v-payment-card :type="guessedCardType" class="image-card"/>
            </div>
        </div>
    </div>
</template>

<script>
    import PaymentCardBrands from '@/data/payment-card-brands';
    import VPaymentCard from '@/components/v-payment-card';

    export default {
        name: 'v-card-number-input',
        components: {
            VPaymentCard,
        },
        props: {
            label: {
                type: String,
                default: null,
            },
            value: {
                type: String,
                default: '',
            },
            validate: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                cardNumber: this.value,
                delimiter: ' ',
            };
        },
        computed: {
            pan() {
                return this.$filters.pan(
                    {
                        pan: this.cardNumber,
                        delimiter: this.delimiter,
                        concat: false,
                    },
                );
            },
            guessedCardType() {
                return this.pan.type && PaymentCardBrands[this.pan.type];
            },
            formattedCardNumber: {
                get() {
                    if (this.guessedCardType) {
                        return this.pan.groups.join(this.delimiter);
                    }
                    return this.cardNumber;
                },
                set(value) {
                    if (this.guessedCardType) {
                        this.cardNumber = value.split(this.delimiter).join('');
                    } else {
                        this.cardNumber = value;
                    }
                },
            },
            isInvalid() {
                if (this.validate) {
                    return this.validate.$invalid && this.validate.$dirty;
                }
                return false;
            },
        },
        methods: {
            input() {
                this.$emit('input', this.cardNumber);
                this.$emit('guessed-card-type', {type: this.guessedCardType});
            },
        },
    };
</script>
